module.exports = __webpack_public_path__ + "static/media/Scene-1.84e7b6ab.jpg";